import { useEffect, useRef } from 'react';

import { useNavigationContext } from '../context/NavigationContext';

export const useAutoExpand = (hasActiveChildren: boolean, isExpanded: boolean, itemText: string) => {
  const { isNavCollapsed, toggleSection } = useNavigationContext();
  const prevIsNavCollapsed = useRef(isNavCollapsed);
  const prevHasActiveChildren = useRef(false);

  // Auto-expand when sidebar transitions from collapsed to expanded
  useEffect(() => {
    const wasCollapsed = prevIsNavCollapsed.current;
    const isNowExpanded = !isNavCollapsed;

    if (wasCollapsed && isNowExpanded && hasActiveChildren && !isExpanded) {
      toggleSection(itemText);
    }

    prevIsNavCollapsed.current = isNavCollapsed;
  }, [isNavCollapsed, hasActiveChildren, isExpanded, itemText, toggleSection]);

  // Auto-expand when navigating directly to a URL with an active nested child.
  // Tracks the false→true transition of hasActiveChildren so the section expands
  // on initial load or address-bar navigation, but does NOT re-expand after the
  // user manually collapses it (prevHasActiveChildren stays true in that case).
  useEffect(() => {
    const hadActiveChildren = prevHasActiveChildren.current;
    prevHasActiveChildren.current = hasActiveChildren;

    if (!hadActiveChildren && hasActiveChildren && !isExpanded && !isNavCollapsed) {
      toggleSection(itemText);
    }
  }, [hasActiveChildren, isExpanded, isNavCollapsed, itemText, toggleSection]);
};
